export class Currency {
	public constructor(public readonly isoCode: string, public readonly name: string) {}
}
